import { render, staticRenderFns } from "./brandPop.vue?vue&type=template&id=4afad144&scoped=true"
import script from "./brandPop.vue?vue&type=script&lang=js"
export * from "./brandPop.vue?vue&type=script&lang=js"
import style0 from "./brandPop.vue?vue&type=style&index=0&id=4afad144&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afad144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4afad144')) {
      api.createRecord('4afad144', component.options)
    } else {
      api.reload('4afad144', component.options)
    }
    module.hot.accept("./brandPop.vue?vue&type=template&id=4afad144&scoped=true", function () {
      api.rerender('4afad144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/brandSelection/components/brandPop.vue"
export default component.exports